import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SubHeader } from '../../../../../../../../commonComponents/CardList/SubHeader';
import { useOfficesSubHeader } from '../hooks';
import { BulkSelect } from './BulkSelect';
import { ViewLinkedOrUnlinked } from './ViewLinkedOrUnlinked';

export const OfficesSubHeader = () => {
  const { id: dsoId } = useParams();
  const { total, onOrderBy, orderBy, isViewUnlinked } = useOfficesSubHeader(dsoId);
  const { selectedGroupId } = useSelector((state) => state.dsos.orgStructure);

  return (
    <SubHeader total={total} onOrderBy={onOrderBy} orderBy={orderBy}>
      <div
        style={{
          paddingRight: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: selectedGroupId ? 'flex-end' : 'space-between',
          width: '100%',
        }}
      >
        {(total > 0 || isViewUnlinked) && <ViewLinkedOrUnlinked dsoId={dsoId} />}
        {total > 0 && <BulkSelect dsoId={dsoId} />}
      </div>
    </SubHeader>
  );
};
